import React from 'react';

import Icon, { Props } from './icon';

export const PauseIcon: React.FC<Props> = (props: Props) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5 3.75C17.1904 3.75 17.75 4.30964 17.75 5V19C17.75 19.6904 17.1904 20.25 16.5 20.25C15.8096 20.25 15.25 19.6904 15.25 19V5C15.25 4.30964 15.8096 3.75 16.5 3.75Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 3.75C8.19036 3.75 8.75 4.30964 8.75 5V19C8.75 19.6904 8.19036 20.25 7.5 20.25C6.80964 20.25 6.25 19.6904 6.25 19V5C6.25 4.30964 6.80964 3.75 7.5 3.75Z"
      />
    </Icon>
  );
};

export default React.memo(PauseIcon);
